import { CreditCard, Wallet, TrendingUp, Building2, FileCheck } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { BillingPanel } from '../admin/BillingPanel';
import { api } from '../../api/client';

/**
 * Página de Billing — hero banner premium + BillingPanel completo.
 */
export function MasterBillingPage() {
  const { data: metricas } = useQuery({
    queryKey: ['billing-metricas-hero'],
    queryFn: async () => {
      const { data } = await api.get('/billing/metricas');
      return data;
    },
    refetchInterval: 60000,
  });

  const mrr = metricas?.mrrEstimado || 0;
  const mrrFmt = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(mrr);
  const totalAss = metricas?.totalAssinaturas || 0;
  const ativas = metricas?.porStatus?.ativas || 0;
  const cobertas = metricas?.totalEscolasCobertas || 0;
  const planos = metricas?.totalPlanos || 0;

  return (
    <div className="admin-page animate-fadeIn">

      {/* ═══ HERO BANNER ═══ */}
      <div style={{
        background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 40%, #4c1d95 100%)',
        borderRadius: 20, padding: '28px 32px', marginBottom: 24, position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', top: -60, right: -60, width: 200, height: 200, borderRadius: '50%', background: 'rgba(139,92,246,.12)' }} />
        <div style={{ position: 'absolute', bottom: -40, left: '40%', width: 160, height: 160, borderRadius: '50%', background: 'rgba(167,139,250,.08)' }} />

        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
            <CreditCard size={18} style={{ color: '#a78bfa' }} />
            <span style={{ color: 'rgba(255,255,255,.4)', fontSize: '.72rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '.12em' }}>
              Financeiro
            </span>
          </div>
          <h1 style={{ color: 'white', fontSize: '1.5rem', fontWeight: 800, margin: 0 }}>
            Billing & Receita
          </h1>
          <p style={{ color: 'rgba(255,255,255,.45)', fontSize: '.82rem', marginTop: 4 }}>
            Gestão financeira e assinaturas da plataforma
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24, marginTop: 24 }}>
            {[
              { icon: Wallet, value: mrrFmt, label: 'MRR Estimado', color: '#a78bfa' },
              { icon: FileCheck, value: `${totalAss} (${ativas} ativas)`, label: 'Assinaturas', color: '#10b981' },
              { icon: Building2, value: cobertas, label: 'Escolas Cobertas', color: '#38bdf8' },
              { icon: TrendingUp, value: planos, label: 'Planos Ativos', color: '#fbbf24' },
            ].map((s, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{
                  width: 48, height: 48, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: `${s.color}20`, color: s.color, backdropFilter: 'blur(10px)',
                }}>
                  <s.icon size={24} />
                </div>
                <div>
                  <div style={{ fontSize: '1.35rem', fontWeight: 900, color: 'white', lineHeight: 1 }}>{s.value}</div>
                  <div style={{ fontSize: '.75rem', color: 'rgba(255,255,255,.6)', fontWeight: 500 }}>{s.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <BillingPanel hideKpis />
    </div>
  );
}
